import { Observable, ReplaySubject, Subject } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { IndicatorState } from '../../../shared/components/sb-pending-button-indicator/sb-pending-button-indicator.component';

// available primary actions
type ActionIds =
    | 'addValuation'
    | 'addFiles'
    | 'addData'
    | 'addTransaction'
    | 'editDetails'
    | 'deleteAsset'
    | 'sellAsset'
    | 'submitValuation'
    | 'deleteValuation';

export interface ActionEvent {
    id: ActionIds;
    $event: MouseEvent;
    state$?: ReplaySubject<IndicatorState>;
}
/** @deprecated - This service shouldn't be used, check with Robert Hjalmers what to use instead. */
@Injectable({ providedIn: 'root' })
export class ModalActionService implements OnDestroy {
    constructor() {}
    _action$ = new Subject<ActionEvent>();
    callAction(id: ActionIds, $event: MouseEvent, state$) {
        this._action$.next({ id, $event, state$ });
    }
    onAction$(id: ActionIds): Observable<ActionEvent> {
        return this._action$
            .asObservable()
            .pipe(filter((actionEvent) => actionEvent.id === id));
    }

    ngOnDestroy(): void {
        this._action$.complete();
    }
}
